






























































































































































































































import { Component, Emit, Prop } from 'vue-property-decorator'
import FormBase from '@/pages/form-base'
import User from '@/models/User'
import axios from 'axios'
import Tag, { ITag } from '@/models/Tag'
import { apiV1TagPath } from '@/rails/routes'
import {Validate} from "@/pages/vue-base"

@Component
export default class BasicForm extends FormBase {
  @Prop(Object) readonly value!: User
  @Prop({ type: Object, default: () => { return {} } }) readonly errors!: object

  @Emit('input')
  input(value: User): User {
    return value
  }

  get internalValue(): User {
    return this.value
  }

  set internalValue(val: User) {
    this.input(val)
  }
  uiTurnTimings: Array<Tag> = []
  recognitionRoutes: Array<Tag> = []
  uiTurnReasons: Array<Tag> = []
  careerItems = [
    { text: 'PG（プログラマー）', value: 'pg' },
    { text: 'SE（システムエンジニア）', value: 'se' },
    { text: 'PM（プロジェクトマネージャー）', value: 'pm' },
    { text: 'WE（WEB制作関連職）', value: 'we' },
    { text: 'NE（ネットワーク/インフラ）', value: 'ne' },
    { text: 'その他', value: 'other' }
  ]
  get emailRules(): Validate[] {
    return this.requiredRules.concat(
        [(v: string) => /.+@.+/.test(v) || 'Emailを入力してください']
    )
  }

  set emailRules(value: Validate[]) {}

  get selectedOtherReasons(): boolean {
    return this.uiTurnReasons.some(reason =>
      this.internalValue.uiTurnReasonIds.includes(reason.id) && reason.name.includes('その他')
    )
  }

  get selectedOtherRecognitionRoutes(): boolean {
    return this.recognitionRoutes.some(route => {
      if (route.children.length) {
        return route
          .children
          .some(child =>
            this.internalValue.recognitionRouteIds.includes(child.id)
            && child.name.includes('その他')
          )
      }
      return this.internalValue.recognitionRouteIds.includes(route.id) && route.name.includes('その他')
    })
  }

  async mounted(): Promise<void> {
    const uiTurnTimingsRoot = await axios.get<ITag>(apiV1TagPath('ui_turn_timings'))
    this.uiTurnTimings = new Tag(uiTurnTimingsRoot.data).children
    const recognitionRoutesRoot = await axios.get<ITag>(apiV1TagPath('recognition_routes'))
    this.recognitionRoutes = new Tag(recognitionRoutesRoot.data).children
    if (this.settings.entry.ui_turn_reasons_automation) {
      const uiTurnReasonsRoot = await axios.get<ITag>(apiV1TagPath('ui_turn_reasons'))
      this.uiTurnReasons = new Tag(uiTurnReasonsRoot.data).children
    }
  }

  public validate(): boolean {
    this.valid = (this.$refs.form as HTMLFormElement).validate()
    this.validated = true
    return this.valid
  }
}
